export default __webpack_public_path__ + "static/media/search.68d25014.svg";